import { TooltipDisabledButton } from "@kanpla/types";
import { Button, ButtonProps, Tooltip } from "antd";
import { cloneDeep } from "lodash";
import React, { ReactNode, useState } from "react";

export interface ActionButtonProps extends ButtonProps, TooltipDisabledButton {
  className: string;
  label: string | ReactNode;
  onClick: () => Promise<void>;
  key?: string;
  dataCy?: string;
}

export const ActionButton = (props: ActionButtonProps) => {
  const {
    onClick,
    label,
    className,
    type = "primary",
    dataCy = "",
    tooltip,
    ...otherProps
  } = props;

  const filteredProps = cloneDeep(props);
  delete filteredProps?.dataCy;

  const [loading, setLoading] = useState(false);

  const _onClick = async () => {
    setLoading(true);
    await onClick();
    setLoading(false);
  };

  if (tooltip?.hasTooltip) {
    return (
      <Tooltip title={tooltip?.title}>
        <Button
          type={type}
          size="large"
          className={`w-full flex-1 ${className || ""}`}
          style={tooltip?.style}
          {...props}
        >
          {label}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      type={type}
      size="large"
      onClick={_onClick}
      loading={loading}
      className={`w-full flex-1 ${className}`}
      data-cy={dataCy}
      {...otherProps}
    >
      {label}
    </Button>
  );
};
